"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/MNFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_153)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_153`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-1.56006 0H34.4399V24H-1.56006V0Z",
					fill: "#095FAD"
				}),
				/* @__PURE__ */ n("path", {
					d: "M22.4399 0H34.4399V24H22.4399V0ZM-1.56006 0H10.4399V24H-1.56006V0Z",
					fill: "#BE1229"
				}),
				/* @__PURE__ */ n("path", {
					d: "M6.04 11.6702H7.0786V16.8772H6.04V11.6702ZM1.87158 11.6702H2.91018V16.8772H1.87158V11.6702Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M4.47512 15.3123C5.04872 15.3123 5.51372 14.8473 5.51372 14.2737C5.51372 13.7001 5.04872 13.2351 4.47512 13.2351C3.90152 13.2351 3.43652 13.7001 3.43652 14.2737C3.43652 14.8473 3.90152 15.3123 4.47512 15.3123Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M3.43652 15.8386H5.52073V16.8772H3.43652V15.8386ZM3.43652 11.6702H5.52073V12.7088H3.43652V11.6702Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M4.47512 11.1438C5.04872 11.1438 5.51372 10.6788 5.51372 10.1052C5.51372 9.53165 5.04872 9.06665 4.47512 9.06665C3.90152 9.06665 3.43652 9.53165 3.43652 10.1052C3.43652 10.6788 3.90152 11.1438 4.47512 11.1438Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M3.79443 8.69471H5.16285L4.47514 7.59998L3.79443 8.69471Z",
					fill: "#FFDA44"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_153`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as MNFlag };
